import gql from 'graphql-tag'
export default gql`
  query SearchVariableFilters {
    SearchVariableFilters @client {
      SearchFilters @client {
        itemType
        value @client {
          value
          op
          valueKey
        }
      }
    }
  }
`
